<!-- src/components/modal/activity-modal.vue -->
<!-- src/components/modal/activity-modal.vue -->
<template>
  <!-- Add / Edit Activity -->
  <div
    class="modal fade dq-activity-modal"
    id="add_activity"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable dq-activity-dialog">
      <div class="modal-content dq-modal-content">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-sky">
              <i class="ti ti-activity"></i>
            </div>

            <div class="dq-headtext">
              <h4 class="modal-title dq-title mb-0">
                {{ isEdit ? "Edit Activity" : "Add New Activity" }}
              </h4>
              <div class="dq-subtitle">
                Log calls, emails, meetings, and tasks — with reminders and links.
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submit">
          <!-- Body -->
          <div class="modal-body dq-modal-body">
            <div class="row g-3">
              <!-- TITLE -->
              <div class="col-12">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-pencil"></i> Activity Details
                    </div>
                    <div class="dq-card-sub">Add a clear title and choose the right type.</div>
                  </div>

                  <div class="row g-3 mt-0">
                    <div class="col-12">
                      <label class="form-label dq-label">
                        Title <span class="text-danger">*</span>
                      </label>
                      <input
                        v-model.trim="form.title"
                        type="text"
                        class="form-control dq-input"
                        placeholder="e.g. Follow-up call with client about proposal"
                        required
                      />
                    </div>

                    <!-- TYPE -->
                    <div class="col-12">
                      <label class="form-label dq-label">
                        Activity Type <span class="text-danger">*</span>
                      </label>

                      <div class="dq-type-grid">
                        <button
                          type="button"
                          class="dq-type"
                          :class="{ active: form.type === 'call' }"
                          @click="form.type = 'call'"
                        >
                          <span class="dq-type-ico"><i class="ti ti-phone"></i></span>
                          <span class="dq-type-txt">
                            <span class="dq-type-title">Call</span>
                            <span class="dq-type-sub">Quick phone follow-up</span>
                          </span>
                        </button>

                        <button
                          type="button"
                          class="dq-type"
                          :class="{ active: form.type === 'email' }"
                          @click="form.type = 'email'"
                        >
                          <span class="dq-type-ico"><i class="ti ti-mail"></i></span>
                          <span class="dq-type-txt">
                            <span class="dq-type-title">Email</span>
                            <span class="dq-type-sub">Send / reply / update</span>
                          </span>
                        </button>

                        <button
                          type="button"
                          class="dq-type"
                          :class="{ active: form.type === 'meeting' }"
                          @click="form.type = 'meeting'"
                        >
                          <span class="dq-type-ico"><i class="ti ti-user-circle"></i></span>
                          <span class="dq-type-txt">
                            <span class="dq-type-title">Meeting</span>
                            <span class="dq-type-sub">In-person / virtual</span>
                          </span>
                        </button>

                        <button
                          type="button"
                          class="dq-type"
                          :class="{ active: form.type === 'task' }"
                          @click="form.type = 'task'"
                        >
                          <span class="dq-type-ico"><i class="ti ti-list-check"></i></span>
                          <span class="dq-type-txt">
                            <span class="dq-type-title">Task</span>
                            <span class="dq-type-sub">Action item to complete</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SCHEDULE + STATUS -->
              <div class="col-12">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-clock"></i> Schedule & Status
                    </div>
                    <div class="dq-card-sub">Set due time, reminder, and current status.</div>
                  </div>

                  <div class="row g-3 mt-0">
                    <div class="col-lg-4">
                      <label class="form-label dq-label">Due Date & Time</label>
                      <input v-model="form.due_at" type="datetime-local" class="form-control dq-input" />
                      <div class="dq-help">Optional, but helps with reminders.</div>
                    </div>

                    <div class="col-lg-4">
                      <label class="form-label dq-label">Reminder (minutes before)</label>
                      <input
                        v-model.number="form.reminder_minutes"
                        type="number"
                        min="1"
                        class="form-control dq-input"
                        placeholder="e.g. 30"
                      />
                      <div class="dq-help">Leave empty to disable reminders.</div>
                    </div>

                    <div class="col-lg-4">
                      <label class="form-label dq-label">Status</label>
                      <select v-model="form.status" class="form-select dq-input">
                        <option value="open">Open</option>
                        <option value="completed">Completed</option>
                        <option value="canceled">Canceled</option>
                      </select>

                      <div
                        class="dq-status mt-2"
                        :class="
                          form.status === 'completed'
                            ? 'dq-status-ok'
                            : form.status === 'canceled'
                            ? 'dq-status-bad'
                            : 'dq-status-warn'
                        "
                      >
                        <i
                          class="ti"
                          :class="
                            form.status === 'completed'
                              ? 'ti-check'
                              : form.status === 'canceled'
                              ? 'ti-x'
                              : 'ti-clock'
                          "
                        ></i>
                        <span>
                          {{
                            form.status === "completed"
                              ? "Marked as completed"
                              : form.status === "canceled"
                              ? "Canceled activity"
                              : "Open activity"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- OWNER + LINK -->
              <div class="col-12">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-link"></i> Ownership & Links
                    </div>
                    <div class="dq-card-sub">
                      Assign an owner and optionally link to deals, contacts, or clients.
                    </div>
                  </div>

                  <div class="row g-3 mt-0">
                    <!-- Owner dropdown -->
                    <div class="col-lg-6">
                      <label class="form-label dq-label">Owner</label>

                      <div class="dropdown w-100 dq-dd" data-bs-auto-close="outside" data-bs-display="static">
                        <button
                          class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                          type="button"
                          data-bs-toggle="dropdown"
                          @click="openOwnerDropdown"
                        >
                          <span class="text-truncate">
                            {{
                              ownerLabel ||
                              (form.owner_id ? `User #${form.owner_id}` : "Select owner")
                            }}
                          </span>
                          <i class="ti ti-chevron-down ms-2"></i>
                        </button>

                        <div class="dropdown-menu p-2 w-100 shadow dq-dd-menu">
                          <input
                            v-model="ownerQuery"
                            @input="onOwnerInput"
                            type="text"
                            class="form-control dq-input mb-2"
                            placeholder="Search users…"
                            autocomplete="off"
                          />

                          <div class="dq-dd-list">
                            <div v-if="ownerLoading" class="text-center py-2 small text-muted">
                              Loading...
                            </div>

                            <button
                              v-for="opt in ownerFiltered"
                              :key="'u-' + opt.id"
                              type="button"
                              class="dropdown-item dq-dd-item"
                              @click="chooseOwner(opt)"
                            >
                              <span class="text-truncate">{{ opt.label }}</span>
                              <i class="ti ti-user-check"></i>
                            </button>

                            <div v-if="!ownerLoading && ownerFiltered.length === 0" class="text-center py-2 small text-muted">
                              No users found
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="dq-help mt-2">If empty, activity stays unassigned.</div>
                    </div>

                    <!-- Link To -->
                    <div class="col-lg-6">
                      <label class="form-label dq-label">Link To</label>

                      <div class="dq-link-choice">
                        <button
                          type="button"
                          class="dq-pill"
                          :class="{ active: !linkChoice }"
                          @click="linkChoice = ''; onLinkChoiceChange();"
                        >
                          None
                        </button>
                        <button
                          type="button"
                          class="dq-pill"
                          :class="{ active: linkChoice === 'deal' }"
                          @click="linkChoice = 'deal'; onLinkChoiceChange();"
                        >
                          Deals
                        </button>
                        <button
                          type="button"
                          class="dq-pill"
                          :class="{ active: linkChoice === 'contact' }"
                          @click="linkChoice = 'contact'; onLinkChoiceChange();"
                        >
                          Contacts
                        </button>
                        <button
                          type="button"
                          class="dq-pill"
                          :class="{ active: linkChoice === 'client' }"
                          @click="linkChoice = 'client'; onLinkChoiceChange();"
                        >
                          Clients
                        </button>
                      </div>

                      <div v-if="linkChoice" class="mt-2">
                        <div class="dropdown w-100 dq-dd" data-bs-auto-close="outside" data-bs-display="static">
                          <button
                            class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                            type="button"
                            data-bs-toggle="dropdown"
                            @click="fetchLinks('', 5)"
                          >
                            <span class="text-truncate">
                              {{
                                selectedLinkLabel ||
                                (form.link_id ? `${linkChoice} #${form.link_id}` : `Select ${linkChoice}`)
                              }}
                            </span>
                            <i class="ti ti-chevron-down ms-2"></i>
                          </button>

                          <div class="dropdown-menu p-2 w-100 shadow dq-dd-menu">
                            <input
                              v-model="linkQuery"
                              @input="onLinkInput"
                              type="text"
                              class="form-control dq-input mb-2"
                              :placeholder="`Search ${linkChoice}s…`"
                              autocomplete="off"
                            />

                            <div class="dq-dd-list">
                              <div v-if="linkLoading" class="text-center py-2 small text-muted">
                                Loading...
                              </div>

                              <button
                                v-for="opt in linkFiltered"
                                :key="'l-' + opt.id"
                                type="button"
                                class="dropdown-item dq-dd-item"
                                @click="chooseLink(opt)"
                              >
                                <span class="text-truncate">{{ opt.label }}</span>
                                <i class="ti ti-link"></i>
                              </button>

                              <div v-if="!linkLoading && linkFiltered.length === 0" class="text-center py-2 small text-muted">
                                No results
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="dq-help mt-2">
                          Linking helps show this activity inside the chosen record.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- DESCRIPTION -->
              <div class="col-12">
                <div class="dq-card">
                  <div class="dq-card-head">
                    <div class="dq-card-title">
                      <i class="ti ti-align-left"></i> Description
                    </div>
                    <div class="dq-card-sub">Add notes, outcomes, or next steps.</div>
                  </div>

                  <div class="ckeditor-wrap">
                    <ckeditor :editor="editor" v-model="editorData" />
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer dq-modal-footer">
            <button
              type="button"
              class="btn btn-light dq-btn dq-btn-muted"
              data-bs-dismiss="modal"
              :disabled="actStore.loading"
            >
              Cancel
            </button>

            <button type="submit" class="btn btn-primary dq-btn dq-btn-primary" :disabled="actStore.loading">
              <span v-if="actStore.loading" class="spinner-border spinner-border-sm me-2"></span>
              {{ isEdit ? "Save Changes" : "Add Activity" }}
              <i class="ti ti-arrow-right ms-2"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal (premium) -->
  <div class="modal fade dq-activity-modal" id="delete_activity" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content dq-modal-content">
        <div class="modal-header dq-modal-header dq-danger-head">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-red">
              <i class="ti ti-trash"></i>
            </div>
            <div>
              <h5 class="modal-title dq-title mb-0">Confirm Delete</h5>
              <div class="dq-subtitle">This action cannot be undone.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body dq-modal-body">
          <div class="dq-danger">
            <i class="ti ti-alert-octagon"></i>
            <div>
              <div class="dq-danger-title">Delete this activity?</div>
              <div class="dq-danger-sub">You’ll remove it from timelines and linked records.</div>
            </div>
          </div>
        </div>

        <div class="modal-footer dq-modal-footer">
          <button type="button" class="btn btn-light dq-btn dq-btn-muted" data-bs-dismiss="modal" :disabled="actStore.loading">
            Cancel
          </button>
          <button
            @click="confirmDelete"
            type="button"
            class="btn btn-danger dq-btn dq-btn-danger"
            :disabled="actStore.loading"
          >
            <span v-if="actStore.loading" class="spinner-border spinner-border-sm me-2"></span>
            Delete <i class="ti ti-trash ms-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted, defineExpose } from "vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useCrmActivityStore } from "@/stores/crmActivityStore";
import { useDealStore } from "@/stores/dealStore";
import { useContactStore } from "@/stores/contactStore";
import { useCrmClientStore } from "@/stores/crmClientStore";
import { useUserStore } from "@/stores/userStore";
import * as Toast from "@/utils/toast";
import * as bootstrap from "bootstrap";

const emit = defineEmits(["saved"]);
const deleteId = ref(null);

// Stores
const actStore = useCrmActivityStore();
const dealStore = useDealStore();
const contactStore = useContactStore();
const clientStore = useCrmClientStore();
const userStore = useUserStore();

const notifyError = (msg) => {
  if (Toast?.toast?.error) return Toast.toast.error(msg);
  if (typeof Toast?.toast === "function") return Toast.toast(msg, "error");
  if (Toast?.error) return Toast.error(msg);
  if (typeof Toast === "function") return Toast(msg, "error");
  console.error(msg);
};
const notifySuccess = (msg) => {
  if (Toast?.toast?.success) return Toast.toast.success(msg);
  if (typeof Toast?.toast === "function") return Toast.toast(msg, "success");
  if (Toast?.success) return Toast.success(msg);
  if (typeof Toast === "function") return Toast(msg, "success");
};

// CKEditor
const editor = ClassicEditor;
const editorData = ref("");

// Form state
const isEdit = ref(false);
const editingId = ref(null);
const form = reactive({
  title: "",
  type: "call",
  due_at: "",
  reminder_minutes: null,
  owner_id: "",
  status: "open",
  description: "",
  link_type: "",
  link_id: "",
});

// Helpers
function baseForm() {
  return {
    title: "",
    type: "call",
    due_at: "",
    reminder_minutes: null,
    owner_id: "",
    status: "open",
    description: "",
    link_type: "",
    link_id: "",
  };
}
function toApiDateTime(localValue) {
  if (!localValue) return "";
  const [d, t] = String(localValue).split("T");
  return `${d} ${t ? `${t}:00` : "00:00:00"}`;
}
function fromApiDateTime(apiValue) {
  if (!apiValue) return "";
  return apiValue.replace(" ", "T").slice(0, 16);
}

// Smart fetch that adapts to your stores
async function smartFetch(storeRef, params = {}) {
  const p = {
    q: String(params?.q ?? ""),
    per_page: params?.per_page ?? 20,
    page: params?.page ?? 1,
  };
  if (typeof storeRef.fetchAll === "function") {
    await storeRef.fetchAll(p);
    if (storeRef.items && "value" in storeRef.items)
      return storeRef.items.value;
    if (Array.isArray(storeRef.items)) return storeRef.items;
    return [];
  }
  if (typeof storeRef.fetchClients === "function") {
    await storeRef.fetchClients(p);
    if (storeRef.clients && "value" in storeRef.clients)
      return storeRef.clients.value;
    if (Array.isArray(storeRef.clients)) return storeRef.clients;
    return [];
  }
  const fn =
    storeRef.list ||
    storeRef.search ||
    storeRef.load ||
    storeRef.fetch ||
    storeRef.index;
  if (!fn) throw new Error("Store has no list/search/load/fetch/index action");
  const resp = await fn(p);
  const out = resp?.data?.data ?? resp?.data ?? resp ?? [];
  return Array.isArray(out) ? out : [];
}

/* ===================== OWNER (searchable dropdown) ===================== */
const ownerQuery = ref("");
const ownerOptions = ref([]); // raw rows mapped => [{id,label}]
const ownerLabel = ref("");
const ownerLoading = ref(false);

function debounce(fn, ms = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

const fetchOwnerOptions = debounce(async (q = "", perPage = 20) => {
  ownerLoading.value = true;
  try {
    const rows = await smartFetch(userStore, { q, per_page: perPage, page: 1 });
    ownerOptions.value = rows
      .filter((u) => u && u.id)
      .map((u) => ({
        id: u.id,
        label:
          u.name ||
          [u.first_name, u.last_name].filter(Boolean).join(" ") ||
          u.email ||
          `User #${u.id}`,
      }));
  } catch (e) {
    notifyError(
      e?.response?.data?.message || e.message || "Failed to load users"
    );
  } finally {
    ownerLoading.value = false;
  }
}, 300);

// client-side filtered view (works even if API ignores q)
const ownerFiltered = computed(() => {
  const q = ownerQuery.value.trim().toLowerCase();
  if (!q) {
    // initial “first 5”
    return ownerOptions.value.slice(0, 5);
  }
  return ownerOptions.value.filter((o) =>
    (o.label || "").toLowerCase().includes(q)
  );
});

function openOwnerDropdown() {
  // seed first 5
  fetchOwnerOptions("", 5);
}
function chooseOwner(opt) {
  form.owner_id = opt.id;
  ownerLabel.value = opt.label;
}
function resolveOwnerLabelById(id) {
  const found = ownerOptions.value.find((o) => o.id === id);
  ownerLabel.value = found?.label || (id ? `User #${id}` : "");
}

// type-as-you-search behavior
function onOwnerInput() {
  const q = ownerQuery.value.trim();
  if (q.length >= 2) {
    // ask server but UI instantly filters whatever we have
    fetchOwnerOptions(q, 20);
  }
}

// add under your other helpers in <script setup>

// Try to fetch a single linked record and return a pretty label
async function fetchLinkLabel(choice, id) {
    console.debug("[ActivityModal] fetchLinkLabel()", { choice, id });

  if (!choice || !id) return "";

  // helper that tries get/show/find/list from a store
  const fetchOne = async (storeRef) => {
    // Prefer get/show/find
    let resp =
      (await storeRef.get?.(id)) ||
      (await storeRef.show?.(id)) ||
      (await storeRef.find?.(id));
    let row = resp?.data || resp;

    // If still nothing, try list with an ID filter fallback (some stores accept q or id)
    if (!row) {
      const lr =
        (await storeRef.list?.({ id })) ||
        (await storeRef.fetch?.({ id })) ||
        (await storeRef.search?.({ id })) ||
        (await storeRef.index?.({ id })) ||
        null;
      row = lr?.data?.data?.[0] || lr?.data?.[0] || lr?.[0] || null;
    }

    return row;
  };

  try {
    if (choice === "deal") {
      const d = await fetchOne(dealStore);
      return d?.name || d?.title || `Deal #${id}`;
    }
    if (choice === "contact") {
      const c = await fetchOne(contactStore);
      return (
        c?.name ||
        [c?.first_name, c?.last_name].filter(Boolean).join(" ") ||
        `Contact #${id}`
      );
    }
    if (choice === "client") {
      const c = await fetchOne(clientStore);
      return c?.name || `Client #${id}`;
    }
  } catch (_) {
    /* ignore and fallback */
  }
  // default fallback
  return `${choice} #${id}`;
}

// Ensure the link UI is prefilled: set choice, label, and seed options with the selected row
async function ensureLinkPrefilled(choice, id) {
  linkChoice.value = choice;
  form.link_type = choice;
  form.link_id = id;

  // 1) Immediate placeholder so UI shows something right away
  const placeholder = `${choice} #${id}`;
  linkLabel.value = placeholder;

  // 2) Ensure the dropdown contains the selected item at top
  if (!linkOptions.value.some((o) => o.id === id)) {
    linkOptions.value = [{ id, label: placeholder }, ...linkOptions.value];
  }

  // 3) Fetch a pretty label in the background, then update UI & options
  try {
    const pretty = await fetchLinkLabel(choice, id);
    if (pretty && pretty !== placeholder) {
      linkLabel.value = pretty;
      const idx = linkOptions.value.findIndex((o) => o.id === id);
      if (idx !== -1) linkOptions.value.splice(idx, 1, { id, label: pretty });
      else linkOptions.value = [{ id, label: pretty }, ...linkOptions.value];
    }
  } catch (_) {
    /* keep placeholder */
  }

  // 4) Hydrate first 5 for browsing (doesn't disturb current selection)
  fetchLinks("", 5);
}

/* ===================== LINK TO (searchable dropdown) ===================== */
const linkChoice = ref(""); // deal | contact | client | ""
const linkQuery = ref("");
const linkOptions = ref([]); // raw rows mapped => [{id,label}]
const linkLabel = ref("");
const linkLoading = ref(false);

const selectedLinkLabel = computed(() => {
  const id = form.link_id;
  if (!id) return "";
  const opt = linkOptions.value.find((o) => o.id === id);
  // prefer option label if we have it; otherwise whatever we fetched into linkLabel
  return opt?.label || linkLabel.value || "";
});

const fetchLinks = debounce(async (q = "", perPage = 20) => {
  if (!linkChoice.value) {
    linkOptions.value = [];
    return;
  }
  linkLoading.value = true;
  try {
    if (linkChoice.value === "deal") {
      const rows = await smartFetch(dealStore, {
        q,
        per_page: perPage,
        page: 1,
      });
      linkOptions.value = rows
        .filter((d) => d && d.id)
        .map((d) => ({
          id: d.id,
          label: d.name || d.title || `Deal #${d.id}`,
        }));
    } else if (linkChoice.value === "contact") {
      const rows = await smartFetch(contactStore, {
        q,
        per_page: perPage,
        page: 1,
      });
      linkOptions.value = rows
        .filter((c) => c && c.id)
        .map((c) => ({
          id: c.id,
          label:
            `${c.first_name || ""} ${c.last_name || ""}`.trim() ||
            c.name ||
            `Contact #${c.id}`,
        }));
    } else if (linkChoice.value === "client") {
      const rows = await smartFetch(clientStore, {
        q,
        per_page: perPage,
        page: 1,
      });
      linkOptions.value = rows
        .filter((c) => c && c.id)
        .map((c) => ({ id: c.id, label: c.name || `Client #${c.id}` }));
    }
  } catch (e) {
    notifyError(
      e?.response?.data?.message || e.message || "Failed to load link options"
    );
  } finally {
    linkLoading.value = false;
  }
}, 300);

// client-side filtered view for Link To
const linkFiltered = computed(() => {
  const q = linkQuery.value.trim().toLowerCase();
  if (!q) return linkOptions.value.slice(0, 5);
  return linkOptions.value.filter((o) =>
    (o.label || "").toLowerCase().includes(q)
  );
});

function onLinkChoiceChange() {
  form.link_type = linkChoice.value || "";
  form.link_id = "";
  linkLabel.value = "";
  linkOptions.value = [];
  linkQuery.value = "";
  if (form.link_type) {
    // first 5
    fetchLinks("", 5);
  }
}
function onLinkInput() {
  const q = linkQuery.value.trim();
  if (q.length >= 2) {
    fetchLinks(q, 20);
  }
}
function chooseLink(opt) {
  form.link_id = opt.id;
  linkLabel.value = opt.label;
}

// ----------------- Open/Edit/Close -----------------
function resetLinkUI() {
  linkChoice.value = "";
  linkOptions.value = [];
  linkLabel.value = "";
  linkQuery.value = "";
}

function openForCreate() {
  Object.assign(form, baseForm());
  editorData.value = "";
  isEdit.value = false;
  editingId.value = null;
  ownerLabel.value = "";
  resetLinkUI();
  // preload first 5 owners so list isn't empty when opened
  fetchOwnerOptions("", 5);
  // also reset queries so any previous input doesn’t leak
  ownerQuery.value = "";
  linkQuery.value = "";
}

async function openForEdit(activity) {
  console.debug("[ActivityModal] openForEdit() -> activity", activity);

  Object.assign(form, baseForm(), {
    title: activity.title,
    type: activity.type,
    due_at: fromApiDateTime(activity.due_at),
    reminder_minutes: activity.reminder_minutes ?? null,
    owner_id: activity.owner_id ?? "",
    status: activity.status ?? "open",
    description: activity.description ?? "",
    link_type: activity.link_type ?? "",
    link_id: activity.link_id ?? "",
  });
  editorData.value = activity.description || "";
  isEdit.value = true;
  editingId.value = activity.id;

  if (form.owner_id) {
    ownerLabel.value =
      activity.owner?.name ||
      [activity.owner?.first_name, activity.owner?.last_name]
        .filter(Boolean)
        .join(" ") ||
      activity.owner_name ||
      `User #${form.owner_id}`;
    // Load options in the background (non-blocking)
    fetchOwnerOptions("", 5);
  } else {
    ownerLabel.value = "";
  }

  if (form.link_type && form.link_id) {
    console.debug(
      "[ActivityModal] prefill link ->",
      form.link_type,
      form.link_id
    );

    await ensureLinkPrefilled(form.link_type, form.link_id);
    console.debug("[ActivityModal] after prefill -> linkLabel:", linkLabel.value,
      "selectedLinkLabel:", selectedLinkLabel.value,
      "options:", linkOptions.value.slice(0, 3));
  } else {
    resetLinkUI();
  }
}

function closeModal(id = "add_activity") {
  const el = document.getElementById(id);
  if (!el) return;
  el.classList.remove("show");
  el.style.display = "none";
  el.setAttribute("aria-hidden", "true");
  el.removeAttribute("aria-modal");
  document.body.classList.remove("modal-open");
  document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
}

// Submit
async function submit() {
  if (!form.title) return notifyError("Title is required");
  if (!form.type) return notifyError("Activity type is required");

  const payload = {
    title: form.title,
    type: form.type,
    due_at: toApiDateTime(form.due_at) || null,
    reminder_minutes: form.reminder_minutes || null,
    owner_id: form.owner_id || null,
    status: form.status,
    description: editorData.value || "",
    link_type: form.link_type || null,
    link_id: form.link_id || null,
  };

  try {
    if (isEdit.value && editingId.value) {
      await actStore.update(editingId.value, payload);
      notifySuccess("Activity updated");
    } else {
      await actStore.create(payload);
      notifySuccess("Activity created");
    }
    emit("saved");
    setTimeout(() => closeModal(), 120);
  } catch (e) {
    notifyError(
      e?.response?.data?.message || e.message || "Failed to save activity"
    );
  }
}

function openDelete(id) {
  deleteId.value = id;
  const el = document.getElementById("delete_activity");
  if (el) new bootstrap.Modal(el).show();
}

async function confirmDelete() {
  if (!deleteId.value) return;
  try {
    await actStore.remove(deleteId.value);
    deleteId.value = null;
    // Close modal
    const el = document.getElementById("delete_activity");
    if (el) bootstrap.Modal.getInstance(el)?.hide();
    // Tell parent to reload
    emit("saved");
  } catch (e) {
    notifyError(e?.response?.data?.message || e.message || "Delete failed");
  }
}

// Lifecycle
onMounted(() => {
  // preload first 5 owners
  fetchOwnerOptions("", 5);
});

// Expose APIs to parent (table) to open modal in edit mode
defineExpose({
  openForCreate,
  openForEdit,
  openForEditFromId: async (id) => {
    const data =
      (await actStore.get?.(id))?.data ||
      (await actStore.show?.(id))?.data ||
      (await actStore.find?.(id))?.data;
    if (!data) {
      notifyError("Failed to load activity");
      return;
    }
    openForEdit(data);
  },
  openDelete,
});
</script>


<style scoped>
/* ===== Modal shell ===== */
.dq-activity-dialog {
  max-width: 1180px;
}
@media (max-width: 992px) {
  .dq-activity-dialog {
    max-width: 96%;
  }
}

.dq-modal-content {
  border-radius: 22px;
  border: none;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08),
    0 40px 90px rgba(15, 23, 42, 0.14);
}

.dq-modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, rgba(56, 189, 248, 0.16), #fff);
}
.dq-danger-head {
  background: linear-gradient(180deg, rgba(239, 68, 68, 0.12), #fff);
}

.dq-modal-body {
  padding: 18px 22px;
}

/* Make scroll always reliable + footer sticky */
.modal-dialog.modal-dialog-scrollable .modal-content {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}
.modal-dialog.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  max-height: calc(92vh - 140px);
  overscroll-behavior: contain;
}
.dq-modal-footer {
  padding: 14px 22px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

/* Header */
.dq-titlewrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dq-title {
  font-weight: 950;
  letter-spacing: -0.35px;
}
.dq-subtitle {
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}
.dq-close {
  opacity: 0.9;
}
.dq-close:hover {
  opacity: 1;
}

/* Hero */
.dq-hero {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.dq-hero-sky {
  background: rgba(56, 189, 248, 0.18);
  color: rgb(2, 132, 199);
}
.dq-hero-red {
  background: rgba(239, 68, 68, 0.14);
  color: rgb(220, 38, 38);
}

/* Cards */
.dq-card {
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  padding: 14px;
}
.dq-card-head {
  padding: 2px 2px 10px;
}
.dq-card-title {
  font-weight: 950;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.dq-card-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.6);
}

/* Inputs */
.dq-label {
  font-size: 0.82rem;
  font-weight: 900;
}
.dq-input {
  border-radius: 14px;
  padding: 10px 12px;
}
.dq-input:focus {
  border-color: rgba(56, 189, 248, 0.55);
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.14);
}
.dq-help {
  margin-top: 6px;
  font-size: 0.8rem;
  color: rgba(15, 23, 42, 0.55);
}

/* ===== Type selector (premium cards) ===== */
.dq-type-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}
@media (max-width: 992px) {
  .dq-type-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 520px) {
  .dq-type-grid {
    grid-template-columns: 1fr;
  }
}
.dq-type {
  width: 100%;
  text-align: left;
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(15, 23, 42, 0.02);
  padding: 12px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  transition: all 0.15s ease;
}
.dq-type:hover {
  background: rgba(56, 189, 248, 0.06);
  border-color: rgba(56, 189, 248, 0.22);
}
.dq-type.active {
  background: rgba(56, 189, 248, 0.10);
  border-color: rgba(56, 189, 248, 0.35);
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.12);
}
.dq-type-ico {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-type.active .dq-type-ico {
  background: rgba(56, 189, 248, 0.16);
  border-color: rgba(56, 189, 248, 0.25);
}
.dq-type-title {
  display: block;
  font-weight: 950;
}
.dq-type-sub {
  display: block;
  margin-top: 2px;
  font-size: 0.78rem;
  color: rgba(15, 23, 42, 0.6);
}

/* ===== Status pill ===== */
.dq-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 14px;
  font-size: 0.82rem;
  font-weight: 900;
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-status-ok {
  background: rgba(16, 185, 129, 0.12);
  color: rgb(5, 150, 105);
}
.dq-status-warn {
  background: rgba(245, 158, 11, 0.12);
  color: rgb(217, 119, 6);
}
.dq-status-bad {
  background: rgba(239, 68, 68, 0.12);
  color: rgb(220, 38, 38);
}

/* ===== Link choice pills ===== */
.dq-link-choice {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.dq-pill {
  border-radius: 999px;
  padding: 8px 12px;
  border: 1px solid rgba(15, 23, 42, 0.10);
  background: rgba(15, 23, 42, 0.02);
  font-weight: 900;
  font-size: 0.82rem;
  transition: all 0.15s ease;
}
.dq-pill:hover {
  background: rgba(56, 189, 248, 0.06);
  border-color: rgba(56, 189, 248, 0.22);
}
.dq-pill.active {
  background: rgba(56, 189, 248, 0.12);
  border-color: rgba(56, 189, 248, 0.35);
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.12);
}

/* ===== Dropdown polish ===== */
.dq-dd-btn {
  border-radius: 14px;
  padding: 10px 12px;
}
.dq-dd-menu {
  border-radius: 16px;
}
.dq-dd-list {
  max-height: 320px;
  overflow: auto;
  overscroll-behavior: contain;
}
.dq-dd-item {
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dq-dd-item:active {
  background: rgba(56, 189, 248, 0.12);
}

/* CKEditor containment */
.ckeditor-wrap :deep(.ck-editor__editable) {
  min-height: 150px;
  max-height: 340px;
  overflow: auto;
  overscroll-behavior: contain;
  border-radius: 14px;
}

/* Buttons */
.dq-btn {
  border-radius: 12px;
  padding: 10px 16px;
  font-weight: 900;
}
.dq-btn-muted {
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-btn-primary {
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.1);
}
.dq-btn-danger {
  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.12);
}

/* Delete warning */
.dq-danger {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(239, 68, 68, 0.14);
  background: rgba(239, 68, 68, 0.08);
}
.dq-danger i {
  font-size: 18px;
  color: rgb(220, 38, 38);
  margin-top: 2px;
}
.dq-danger-title {
  font-weight: 950;
}
.dq-danger-sub {
  margin-top: 6px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.7);
}
</style>


<!-- <style scoped>
/* Visual state for selected type buttons */
.activity-items .btn.active {
  color: #fff;
  background: var(--bs-primary);
  border-color: var(--bs-primary);
}

/* === Make modal scroll reliably within viewport === */
.modal-dialog.modal-dialog-scrollable .modal-content {
  max-height: 92vh; /* keep whole modal inside the viewport */
  display: flex;
  flex-direction: column;
}
.modal-dialog.modal-dialog-scrollable .modal-body {
  overflow-y: auto; /* the scrollable area */
  max-height: calc(92vh - 120px); /* header+footer allowance; tweak if needed */
  overscroll-behavior: contain;
}

/* Dropdowns: scroll independently and don’t trap the modal scroll */
.dropdown-menu {
  max-height: 340px;
  overflow: auto;
  overscroll-behavior: contain;
}
.search-list .dropdown-item {
  white-space: nowrap;
}

/* CKEditor containment */
.ckeditor-wrap :deep(.ck-editor__editable) {
  min-height: 140px;
  max-height: 320px;
  overflow: auto;
  overscroll-behavior: contain;
}
</style> -->
